"use strict";

function cov_2gvdbmxl85() {
  var path = "/__w/code/code/js/packages/bricks/src/system/theme/variants.types.ts";
  var hash = "59cc4f4db85b956539cff881d8f3b9cb10ef8a3f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/system/theme/variants.types.ts",
    statementMap: {},
    fnMap: {},
    branchMap: {},
    s: {},
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "59cc4f4db85b956539cff881d8f3b9cb10ef8a3f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2gvdbmxl85 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2gvdbmxl85();